import { Action, ActionReducer, MetaReducer, createReducer, on } from '@ngrx/store';
import { BasicDataActionTypes, getBasicDataSuccess, updateBasicDataSuccess } from '../actions';
import { IBasicData } from '@shared/model/basic-data';
import { IRootState, RootActionTypes } from '@app/store';

const initialState: IBasicData = {
  comments: undefined,
  currency: undefined,
  currency_multiplication: undefined,
  fin_source_credit: undefined,
  fin_source_equity: undefined,
  fin_source_leasing: undefined,
  financing_type: undefined,
  industry_main: undefined,
  industry_segments: undefined,
  name: undefined,
  time_detalization: undefined,
  use_purchases: false,
};

export const basicDataReducer = createReducer(
  initialState,
  // on(getBasicDataSuccess, (state, { basicData }) => basicData ),
  on(getBasicDataSuccess, (state, { basicData }) => {
    return { ...basicData };
  }),
  on(updateBasicDataSuccess, (state, { data }) => ({ ...state, [data.name]: data.value })),
);

export function clearState(reducer: ActionReducer<IRootState>) {
  return function (state: IRootState | undefined, action: Action) {
    if (action.type === BasicDataActionTypes.CLEAR_BASIC_DATA) return reducer(undefined, action);
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer[] = [clearState];
